import { IResourceListItem } from "./Models";

export interface IResourceListItemBase {
	Id: number,
	Name: string,
}

export function parseToString(data: IResourceListItemBase[]): string {
	let result = data.map(item => item.Id + ": " + item.Name).join("*&*,");
	return result;
}

export function parseFromString(data: string): IResourceListItem[] {
	if (!data)
		return [];

	let result = data.split("*&*,").map(x => {
		let chunks = x.split(':');

		let item = {
			Id: parseInt(chunks[0].trim()),
			Name: chunks[1].trim(),
		};
		return item as IResourceListItem;
	});
	return result;
}
